import type { ModelKey } from "@/modules/model";

import { useModelNavigate } from "@/modules/model-navigate";

export function useNavigateToRessource<T>(
  model: ModelKey,
  idAccessor: (response: T) => number
): (response: T) => void {
  const { navigateToModel } = useModelNavigate();

  const navigateToRessource = (response: T) => {
    const id = idAccessor(response);
    navigateToModel(model, { id });
  };

  return navigateToRessource;
}
